import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Month navigation component for the timeline
 * @param {Object} props - Component props
 * @param {number} props.currentMonth - Current month (0-11)
 * @param {number} props.currentYear - Current year
 * @param {Function} props.onPreviousMonth - Previous month handler
 * @param {Function} props.onNextMonth - Next month handler
 */
const MonthNavigation = ({ currentMonth, currentYear, onPreviousMonth, onNextMonth }) => {
  return (
    <div className="bg-gray-100 p-4 flex justify-between items-center border-b border-gray-200">
      <button 
        onClick={onPreviousMonth}
        className="p-2 rounded-full hover:bg-gray-200 transition-colors"
      >
        <ChevronLeft size={20} />
      </button>
      <h2 className="text-lg font-light text-gray-800">
        {new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' })}
      </h2>
      <button 
        onClick={onNextMonth}
        className="p-2 rounded-full hover:bg-gray-200 transition-colors"
      >
        <ChevronRight size={20} />
      </button>
    </div>
  );
};

export default MonthNavigation;